/** Описание пункта таб-бара, управляемого из сервиса (для ui.setTabBar). */
export interface ITabItem {
  id: string;
  label: string;
  /** Имя иконки из ui-kit. */
  icon?: string;
  badge?: number | string;
}

/** Конфигурация таб-бара сервиса, задаваемая из web. */
export interface ITabBarConfig {
  visible?: boolean;
  items?: ITabItem[];
  activeId?: string;
}
